import { Organization } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const updateOrganization: (
  fetchContext: FetchContext,
  organization: Organization,
  accessToken?: string,
) => Promise<void> = (fetchContext, organization, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/organizations/${organization.organizationId}`, {
    method: 'PUT',
    body: JSON.stringify(organization),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<void>(fetchContext.errorStore, response, 'update organization'));
